import { render, staticRenderFns } from "./SlideCard.vue?vue&type=template&id=07ec08c3&scoped=true&"
import script from "./SlideCard.vue?vue&type=script&lang=js&"
export * from "./SlideCard.vue?vue&type=script&lang=js&"
import style0 from "./SlideCard.vue?vue&type=style&index=0&id=07ec08c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ec08c3",
  null
  
)

export default component.exports